import { useCallback, useEffect, useMemo, useState } from 'react';
import { getActiveMark, setMarkCommand } from '../utils/markUtils';
import UITextToolbarSelect from 'rich-text-lib/components/editor/UITextToolbarSelect';
import { FONT_STYLES } from '../constants/fontConstants';
import { PM_FORMATTING } from '../constants/events';
import { CHANGE_FONT } from 'rich-text-lib/constants/usageTracking';
import { Tracker } from '../../utils/usageTracker';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import I18n from 'I18n';
import { parseAvailableFont } from '../utils/fontUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const setFontStyle = attrs => setMarkCommand(schema => schema.marks.font_style, attrs);
const getAvailableFont = fontStyle => fontStyle && parseAvailableFont(fontStyle) || FONT_STYLES[0].value;
export default function FontStyleMark({
  defaultFontStyle
}) {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const defaultAvailableStyle = useMemo(() => {
    return getAvailableFont(defaultFontStyle);
  }, [defaultFontStyle]);
  const [styleValue, setStyleValue] = useState(defaultAvailableStyle);
  useEffect(() => {
    const activeFontStyle = getActiveMark(editorState, editorState.schema.marks.font_style);
    if (activeFontStyle) {
      setStyleValue(getAvailableFont(activeFontStyle.attrs.style));
    } else {
      setStyleValue(defaultAvailableStyle);
    }
  }, [editorState, setStyleValue, defaultAvailableStyle]);
  const applyFontStyle = useCallback(evt => {
    setFontStyle({
      style: evt.target.value
    })(editorState, tr => {
      const newTr = tr.setMeta('font_style', evt.target.value);
      setEditorState(editorState.apply(newTr));
    });
    setStyleValue(evt.target.value);
    Tracker.track(PM_FORMATTING, {
      action: CHANGE_FONT,
      method: 'toolbar',
      value: evt.target.value
    });
  }, [editorState, setEditorState, setStyleValue]);
  return /*#__PURE__*/_jsx(UITextToolbarSelect, {
    "data-test-id": "font-styles-dropdown",
    className: "font-styles-dropdown"
    // @ts-expect-error not recorded in types
    ,
    onChange: applyFontStyle,
    options: [...FONT_STYLES],
    value: styleValue,
    placeholder: I18n.text('hubspot-prosemirror.buttons.fontStylePlaceholder')
  });
}